import React, { useEffect, useState } from 'react';
import EarthVisualization from './components/EarthVisualization';
import FilterPanel from './components/FilterPanel';
import { fetchSatelliteData } from './utils/satelliteData';
import { Satellite } from './types/satellite';
export function App() {
  const [satellites, setSatellites] = useState<Satellite[]>([]);
  const [loading, setLoading] = useState(true);
  const [filters, setFilters] = useState({
    country: 'all',
    purpose: 'all',
    technology: 'all',
    minLaunchYear: 1957,
    maxLaunchYear: new Date().getFullYear()
  });
  useEffect(() => {
    const loadData = async () => {
      setLoading(true);
      try {
        const data = await fetchSatelliteData();
        setSatellites(data);
      } catch (error) {
        console.error('Failed to load satellite data:', error);
      } finally {
        setLoading(false);
      }
    };
    loadData();
  }, []);
  const filteredSatellites = satellites.filter(sat => {
    if (filters.country !== 'all' && sat.country !== filters.country) return false;
    if (filters.purpose !== 'all' && sat.purpose !== filters.purpose) return false;
    if (filters.technology !== 'all' && sat.technology !== filters.technology) return false;
    if (sat.launchYear < filters.minLaunchYear || sat.launchYear > filters.maxLaunchYear) return false;
    return true;
  });
  const availableCountries = [...new Set(satellites.map(sat => sat.country))];
  const availablePurposes = [...new Set(satellites.map(sat => sat.purpose))];
  const availableTechnologies = [...new Set(satellites.map(sat => sat.technology))];
  return <div className="flex flex-col lg:flex-row w-full h-screen bg-black text-white" data-id="element-0">
      <div className="lg:w-3/4 h-full" data-id="element-1">
        {loading ? <div className="w-full h-full flex items-center justify-center" data-id="element-2">
            <div className="text-2xl" data-id="element-3">Loading satellite data...</div>
          </div> : <EarthVisualization satellites={filteredSatellites} data-id="element-4" />}
      </div>
      <div className="lg:w-1/4 p-4 bg-gray-900 overflow-y-auto" data-id="element-5">
        <h1 className="text-2xl font-bold mb-4" data-id="element-6">Earth Satellite Tracker</h1>
        <div className="mb-4" data-id="element-7">
          <p className="text-sm text-gray-400" data-id="element-8">
            Showing {filteredSatellites.length} of {satellites.length}{' '}
            satellites
          </p>
        </div>
        <FilterPanel filters={filters} setFilters={setFilters} availableCountries={availableCountries} availablePurposes={availablePurposes} availableTechnologies={availableTechnologies} minYear={1957} maxYear={new Date().getFullYear()} data-id="element-9" />
      </div>
    </div>;
}